import { Modal } from '@morningtrain/react-modals'
import { RouterHelper } from '@morningtrain/react-navigation'

Modal.defaultProps = {
  ...Modal.defaultProps,
  closeIcon: (new RouterHelper()).url('icons/close.svg')
}

export { Base, Label, Trigger } from '@morningtrain/react-modals'
export { Modal }
